import { ListItem, ListItemIcon, ListItemText, ListItemButton } from '@mui/material';
import { useNavigate } from 'react-router';
import useRouteMatch from '@hooks/useRouteMatch';
import { MobileMenuProps, NavbarLink } from './types';

import styles from './NavigationBarItem.module.css';

type NavigationBarItemProps = MobileMenuProps & {
	item: NavbarLink;
	/** Is the Parent Navigation Bar open */
	open: boolean;
	isMobile: boolean;
};

export default function NavigationBarItem(props: NavigationBarItemProps) {
	const navigate = useNavigate();
	const { isCurrentRoute } = useRouteMatch();

	const handleClick = () => {
		if (props.item.onClick) {
			props.item.onClick();
		}

		if (props.item.destination) {
			void navigate(props.item.destination);
		}
		// When we are in mobile, clicking the link should close the menu
		if (props.isMobile) {
			props.setMobileMenuOpen(!props.mobileMenuOpen);
		}
	};

	return (
		<ListItem
			disablePadding
			className={`${styles['navigation-item']} ${props.item.destination && isCurrentRoute(props.item.destination) ? styles.active : ''}`}
			title={props.item.title}
		>
			<ListItemButton
				className={styles['navigation-item-btn']}
				onClick={() => {
					handleClick();
				}}
			>
				<ListItemIcon className={styles['navigation-item-btn-icon']}>{props.item.icon}</ListItemIcon>

				<ListItemText
					primary={props.item.displayText}
					slotProps={{
						primary: {
							className: `${styles['navigation-item-btn-text']} ${!props.open && !props.isMobile ? styles.hidden : ''}`,
							variant: 'body1'
						}
					}}
				/>
			</ListItemButton>
		</ListItem>
	);
}
